export default "__VITE_ASSET__GfZsxEr5__"